"use client"
import LegalPageLayout, { LegalBodyText, LegalHeadline } from "../src/components/LegalPageLayout"
import { Routes } from "../src/data/routes"

const Privacy = () => {
  return (
    <LegalPageLayout
      headTitle={"Datenschutzerklärung | Skinuvita"}
      headDescription={
        "Wie die Skinuvita GmbH personenbezogene Daten auf www.skinuvita.de und in den " +
        "Social-Media-Profilen verarbeitet."
      }
      canonicalPath={Routes.datenschutz}
    >
      <LegalHeadline>DATENSCHUTZERKLÄRUNG DER WEBSITE</LegalHeadline>

      <LegalHeadline>1. Einleitung</LegalHeadline>
      <LegalBodyText>
        Im Folgenden informieren wir über die Verarbeitung personenbezogener Daten bei der Nutzung
        <ul>
          <li>unserer Website https://www.skinuvita.de</li>
          <li>unserer Profile in Sozialen Medien.</li>
        </ul>
        Personenbezogene Daten sind alle Daten, die auf eine konkrete natürliche Person beziehbar sind, z. B. ihr Name
        oder ihre IP-Adresse.
      </LegalBodyText>
      <LegalHeadline>1.1. Kontaktdaten</LegalHeadline>
      <LegalBodyText>
        Verantwortlicher gem. Art. 4 Abs. 7 EU-Datenschutz-Grundverordnung (DSGVO) ist Skinuvita GmbH, Altenwall 1-3,
        28195 Bremen, Deutschland, E-Mail: info@skinuvita.de. Gesetzlich vertreten werden wir durch Jan B. Elsner,
        Dr.-Ing. Jens Pelzetter. Unser Datenschutzbeauftragter ist über die heyData GmbH, Schützenstraße 5, 10117
        Berlin, www.heydata.eu, E-Mail: datenschutz@heydata.eu erreichbar.
      </LegalBodyText>
      <LegalHeadline>1.2. Umfang der Datenverarbeitung, Verarbeitungszwecke und Rechtsgrundlagen</LegalHeadline>
      <LegalBodyText>
        Den Umfang der Verarbeitung der Daten, Verarbeitungszwecke und Rechtsgrundlagen führen wir im Detail weiter
        unten aus. Als Rechtsgrundlage für eine Datenverarbeitung kommen grundsätzlich die folgenden in Betracht:
        <ul>
          <li>
            Art. 6 Abs. 1 S. 1 lit. a DSGVO dient uns als Rechtsgrundlage für Verarbeitungsvorgänge, für die wir eine
            Einwilligung einholen.
          </li>
          <li>
            Art. 6 Abs. 1 S. 1 lit. b DSGVO ist Rechtsgrundlage, soweit die Verarbeitung personenbezogener Daten zur
            Erfüllung eines Vertrages erforderlich ist, z.B. wenn ein Seitenbesucher von uns ein Produkt erwirbt oder
            wir für ihn eine Leistung ausführen. Diese Rechtsgrundlage gilt auch für Verarbeitungen, die für
            vorvertragliche Maßnahmen erforderlich sind, etwa bei Anfragen zu unseren Produkten oder Leistungen.
          </li>
          <li>
            Art. 6 Abs. 1 S. 1 lit. c DSGVO findet Anwendung, wenn wir mit der Verarbeitung personenbezogener Daten eine
            rechtliche Verpflichtung erfüllen, wie es z.B. im Steuerrecht der Fall sein kann.
          </li>
          <li>
            Art. 6 Abs. 1 S. 1 lit. f DSGVO dient als Rechtsgrundlage, wenn wir uns zur Verarbeitung personenbezogener
            Daten auf berechtigte Interessen berufen können, z.B. für Cookies, die für den technischen Betrieb unserer
            Website erforderlich sind.
          </li>
        </ul>
      </LegalBodyText>
      <LegalHeadline>1.3. Datenverarbeitung außerhalb des EWR</LegalHeadline>
      <LegalBodyText>
        Soweit wir Daten an Dienstleister oder sonstige Dritte außerhalb des EWR übermitteln, garantieren
        Angemessenheitsbeschlüsse der EU-Kommission nach Art. 45 Ab. 3 DSGVO die Sicherheit der Daten bei der
        Weitergabe, soweit diese vorhanden sind, wie dies z.B. für Großbritannien, Kanada und Israel der Fall ist. Bei
        der Datenweitergabe an Dienstleister in den USA, ist Rechtsgrundlage für die Datenweitergabe ein
        Angemessenheitsbeschluss der EU-Kommission, wenn sich der Dienstleister zusätzlich unter dem EU US Data Privacy
        Framework zertifiziert hat. In anderen Fällen (z.B. wenn kein Angemessenheitsbeschluss existiert), sind
        Rechtsgrundlage für die Datenweitergabe im Regelfall, also soweit wir keinen abweichenden Hinweis geben,
        Standardvertragsklauseln. Diese sind ein von der EU-Kommission verabschiedetes Regelwerk und Teil des Vertrags
        mit dem jeweiligen Dritten. Nach Art. 46 Abs. 2 lit. b DSGVO gewährleisten sie die Sicherheit der
        Datenweitergabe. Viele der Anbieter haben über die Standardvertragsklauseln hinausgehende vertragliche Garantien
        abgegeben, die die Daten über die Standardvertragsklauseln hinaus schützen. Das sind z.B. Garantien hinsichtlich
        der Verschlüsselung der Daten oder hinsichtlich einer Pflicht des Dritten zum Hinweis an Betroffene, wenn
        Strafverfolgungsorgane auf Daten zugreifen wollen.
      </LegalBodyText>
      <LegalHeadline>1.4. Speicherdauer</LegalHeadline>
      <LegalBodyText>
        Sofern nicht im Rahmen dieser Datenschutzerklärung ausdrücklich angegeben, werden die bei uns gespeicherten
        Daten gelöscht, sobald sie für ihre Zweckbestimmung nicht mehr erforderlich sind und der Löschung keine
        gesetzlichen Aufbewahrungspflichten entgegenstehen. Sofern die Daten nicht gelöscht werden, weil sie für andere
        und gesetzlich zulässige Zwecke erforderlich sind, wird ihre Verarbeitung eingeschränkt, d.h. die Daten werden
        gesperrt und nicht für andere Zwecke verarbeitet. Das gilt z.B. für Daten, die wir aus handels- oder
        steuerrechtlichen Gründen aufbewahren müssen.
      </LegalBodyText>
      <LegalHeadline>1.5. Rechte der Betroffenen</LegalHeadline>
      <LegalBodyText>
        Betroffene haben gegenüber uns folgende Rechte hinsichtlich der sie betreffenden personenbezogenen Daten:
        <ul>
          <li>Recht auf Auskunft,</li>
          <li>Recht auf Berichtigung oder Löschung,</li>
          <li>Recht auf Einschränkung der Verarbeitung,</li>
          <li>
            <b>Recht auf Widerspruch gegen die Verarbeitung,</b>
          </li>
          <li>Recht auf Datenübertragbarkeit,</li>
          <li>
            <b>Recht, eine erteilte Einwilligung jederzeit zu widerrufen.</b>
          </li>
        </ul>
        Betroffene haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung ihrer
        personenbezogenen Daten zu beschweren. Kontaktdaten der Datenschutz-Aufsichtsbehörden sind unter
        https://www.bfdi.bund.de/DE/Service/Anschriften/Laender/Laender-node.html abrufbar.
      </LegalBodyText>
      <LegalHeadline>1.6. Pflicht zur Bereitstellung von Daten</LegalHeadline>
      <LegalBodyText>
        Kunden, Interessenten oder Dritte müssen uns im Rahmen einer Geschäftsbeziehung oder sonstigen Beziehung nur
        diejenigen personenbezogenen Daten bereitstellen, die für die Begründung, Durchführung und Beendigung der
        Geschäftsbeziehung oder für die sonstige Beziehung erforderlich sind oder zu deren Erhebung wir gesetzlich
        verpflichtet sind. Ohne diese Daten werden wir in der Regel den Abschluss eines Vertrages oder die
        Bereitstellung einer Leistung ablehnen müssen oder einen bestehenden Vertrag oder sonstige Beziehung nicht mehr
        durchführen können. Pflichtangaben sind als solche gekennzeichnet.
      </LegalBodyText>
      <LegalHeadline>1.7. Keine automatische Entscheidungsfindung im Einzelfall</LegalHeadline>
      <LegalBodyText>
        Zur Begründung und Durchführung einer Geschäftsbeziehung oder sonstigen Beziehung nutzen wir grundsätzlich keine
        vollautomatisierte Entscheidungsfindung gemäß Artikel 22 DSGVO. Sollten wir diese Verfahren in Einzelfällen
        einsetzen, werden wir hierüber gesondert informieren, sofern dies gesetzlich geboten ist.
      </LegalBodyText>
      <LegalHeadline>1.8. Kontaktaufnahme</LegalHeadline>
      <LegalBodyText>
        Bei der Kontaktaufnahme mit uns, z.B. per E-Mail oder Telefon, werden die uns mitgeteilten Daten (z.B. Namen und
        E-Mail-Adressen) von uns gespeichert, um Fragen zu beantworten. Rechtsgrundlage für die Verarbeitung ist unser
        berechtigtes Interesse (Art. 6 Abs. 1 S. 1 lit. f DSGVO), an uns gerichtete Anfragen zu beantworten. Die in
        diesem Zusammenhang anfallenden Daten löschen wir, nachdem die Speicherung nicht mehr erforderlich ist, oder
        schränken die Verarbeitung ein, falls gesetzliche Aufbewahrungspflichten bestehen.
      </LegalBodyText>
      <LegalHeadline>1.9. Kundenumfragen</LegalHeadline>
      <LegalBodyText>
        Von Zeit zu Zeit führen wir Kundenumfragen durch, um unsere Kunden und ihre Wünsche besser kennenzulernen. Dabei
        erheben wir die jeweils abgefragten Daten. Es ist unser berechtigtes Interesse, unsere Kunden und ihre Wünsche
        besser kennenzulernen, so dass Rechtsgrundlage der damit einhergehenden Datenverarbeitung Art. 6 Abs. 1 S. 1 lit
        f DSGVO ist. Die Daten löschen wir, wenn die Ergebnisse der Umfragen ausgewertet sind.
      </LegalBodyText>
      <LegalHeadline>2. Newsletter</LegalHeadline>
      <LegalBodyText>
        Wir behalten uns vor, Kunden, die bereits Dienstleistungen von uns in Anspruch genommen haben oder Waren gekauft
        haben, von Zeit zu Zeit per E-Mail oder auf anderem Weg über unsere Angebote zu informieren, falls sie dem nicht
        widersprochen haben. Rechtsgrundlage für diese Datenverarbeitung ist Art. 6 Abs. 1 S. 1 lit. f DSGVO. Unser
        berechtigtes Interesse liegt in der Direktwerbung (Erwägungsgrund 47 DSGVO). Kunden können der Verwendung ihrer
        E-Mail-Adresse zu Werbezwecken jederzeit ohne zusätzliche Kosten widersprechen, zum Beispiel über den Link am
        Ende einer jeden E-Mail oder per E-Mail an unsere oben genannte E-Mail-Adresse. Wir versenden Newsletter mit dem
        Tool Pipedrive des Anbieters Pipedrive OÜ, Mustamäe tee 3a, 10615 Tallinn, Estland Der Anbieter verarbeitet
        dabei Inhalts-, Nutzungs-, Meta-/Kommunikationsdaten und Kontaktdaten in der EU. Weitere Informationen sind in
        der Datenschutzerklärung des Anbieters unter https://www.pipedrive.com/en/privacy abrufbar.
      </LegalBodyText>
      <LegalHeadline>3. Datenverarbeitung auf unserer Website</LegalHeadline>
      <LegalHeadline>3.1. Hinweis für Websitebesucher aus Deutschland</LegalHeadline>
      <LegalBodyText>
        Unsere Website speichert Informationen in der Endeinrichtung von Websitebesuchern (z.B. Cookies) oder greift auf
        Informationen zu, die bereits in der Endeinrichtung gespeichert sind (z.B. IP-Adressen). Welche Informationen
        dies im Einzelnen sind, ist den folgenden Abschnitten zu entnehmen. Diese Speicherung und dieser Zugriff erfolgt
        auf Grundlage der folgenden Bestimmungen:
        <ul>
          <li>
            Soweit diese Speicherung oder dieser Zugriff unbedingt erforderlich ist, damit wir dem von Websitebesuchern
            ausdrücklich gewünschten Dienst unserer Website zur Verfügung stellen (z.B. zur Durchführung eines vom
            Websitebesucher genutzten Chatbot oder zur Sicherstellung der IT-Sicherheit unserer Website), erfolgt sie
            auf Grundlage von § 25 Abs. 2 Nr. 2 des Telekommunikation-Digitale-Dienste-Datenschutz-Gesetzes (TDDDG).
          </li>
          <li>
            Im Übrigen erfolgt diese Speicherung oder dieser Zugriff auf Grundlage der Einwilligung der Websitebesucher
            (§ 25 Abs. 1 TDDDG).
          </li>
        </ul>{" "}
        Die nachgelagerte Datenverarbeitung erfolgt nach Maßgabe der folgenden Abschnitte und auf Grundlage der
        Vorschriften der DSGVO.
      </LegalBodyText>
      <LegalHeadline>3.2. Informatorische Nutzung der Website</LegalHeadline>
      <LegalBodyText>
        Bei der informatorischen Nutzung der Website, also wenn Seitenbesucher uns nicht gesondert Informationen
        übermitteln, erheben wir die personenbezogenen Daten, die der Browser an unseren Server übermittelt, um die
        Stabilität und Sicherheit unserer Website zu gewährleisten. Darin liegt unser berechtigtes Interesse, so dass
        Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. f DSGVO ist. Diese Daten sind:
        <ul>
          <li>IP-Adresse</li>
          <li>Datum und Uhrzeit der Anfrage</li>
          <li>Zeitzonendifferenz zur Greenwich Mean Time (GMT)</li>
          <li>Inhalt der Anfrage (konkrete Seite)</li>
          <li>Zugriffsstatus/HTTP-Statuscode</li>
          <li>jeweils übertragene Datenmenge</li>
          <li>Website, von der die Anfrage kommt</li>
          <li>Browser</li>
          <li>Betriebssystem und dessen Oberfläche</li>
          <li>Sprache und Version der Browsersoftware.</li>
        </ul>
        Diese Daten werden außerdem in Logfiles gespeichert. Sie werden gelöscht, wenn ihre Speicherung nicht mehr
        erforderlich ist, spätestens nach 14 Tagen.
      </LegalBodyText>
      <LegalHeadline>3.3. Webhosting und Bereitstellung der Website</LegalHeadline>
      <LegalBodyText>
        Unsere Website hostet Hetzner. Anbieter ist Hetzner Online GmbH, Industriestr. 25, 91710 Gunzenhausen. Der
        Anbieter verarbeitet dabei die über die Website übermittelten personenbezogenen Daten, z.B. Inhalts-, Nutzungs-,
        Meta-/Kommunikationsdaten oder Kontaktdaten, in der EU. Weitere Informationen finden sich in der
        Datenschutzerklärung des Anbieters unter https://www.hetzner.com/de/rechtliches/datenschutz. Es ist unser
        berechtigtes Interesse, eine Website zur Verfügung zu stellen, so dass die Rechtsgrundlage der beschriebenen
        Datenverarbeitung Art. 6 Abs. 1 S. 1 lit. f DSGVO ist.
      </LegalBodyText>
      <LegalHeadline>3.4. Drittanbieter</LegalHeadline>
      <LegalHeadline>3.4.1. Matomo</LegalHeadline>
      <LegalBodyText>
        Wir setzen Matomo zur Analyse ein. Der Anbieter ist InnoCraft Ltd., 150 Willis St, 6011 Wellington, Neuseeland.
        Die Verarbeitung erfolgt aber nur auf unseren Servern. Wir verarbeiten Nutzungsdaten (z.B. besuchte Webseiten,
        Interesse an Inhalten, Zugriffszeiten) und Meta-/Kommunikationsdaten (z.B. Geräte-Informationen, IP-Adressen) in
        der EU. Die Rechtsgrundlage der Verarbeitung ist Art. 6 Abs. 1 S. 1 lit. a DSGVO. Die Verarbeitung erfolgt auf
        der Basis von Einwilligungen. Betroffene können ihre Einwilligung jederzeit widerrufen, indem sie uns z.B. unter
        den in unserer Datenschutzerklärung angegebenen Kontaktdaten kontaktieren. Der Widerruf berührt nicht die
        Rechtmäßigkeit der Verarbeitung bis zum Widerruf. Die Daten werden gelöscht, wenn der Zweck ihrer Erhebung
        entfallen ist und keine Aufbewahrungspflichten entgegenstehen. Weitere Informationen sind in der
        Datenschutzerklärung des Anbieters unter https://matomo.org/privacy-policy/ abrufbar.
      </LegalBodyText>
      <LegalHeadline>3.4.2. heyData</LegalHeadline>
      <LegalBodyText>
        Wir haben ein Datenschutz-Siegel auf unserer Website eingebunden. Der Anbieter ist heyData GmbH, Schützenstraße
        5, 10117 Berlin, Deutschland. Der Anbieter verarbeitet Meta-/Kommunikationsdaten (z.B. IP-Adressen) in der EU.
        Die Rechtsgrundlage der Verarbeitung ist Art. 6 Abs. 1 S. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse,
        Website-Besuchern eine Bestätigung über unsere Datenschutz-Compliance zur Verfügung zu stellen. Gleichzeitig hat
        der Anbieter ein berechtigtes Interesse daran, sicherzustellen, dass nur Kunden mit bestehenden Verträgen seine
        Siegel nutzen, weshalb eine bloße Bildkopie des Zertifikats keine gangbare Alternative zur Bestätigung
        darstellt. Die Daten werden nach der Erhebung maskiert, damit kein Personenbezug mehr besteht. Weitere
        Informationen sind in der Datenschutzerklärung des Anbieters unter https://heydata.eu/datenschutzerklaerung
        abrufbar.
      </LegalBodyText>
      <LegalHeadline>3.4.3. WhatsApp</LegalHeadline>
      <LegalBodyText>
        Wir nutzen WhatsApp, um mit Kunden zu kommunizieren. Der Anbieter ist WhatsApp Ireland Limited, 4 Grand Canal
        Square, Grand Canal Harbour, Dublin 2, Irland. Der Anbieter verarbeitet Kommunikationsdaten (Rufnummer, Name,
        Nachrichten) in den USA. Die Rechtsgrundlage für die Verarbeitung ist Art. 6 Abs. 1 S. 1 lit. a DSGVO. Die
        Verarbeitung beruht auf einer Einwilligung. Betroffene Personen können ihre Einwilligung jederzeit widerrufen,
        indem sie uns z. B. über die in unserer Datenschutzerklärung angegebenen Kontaktdaten kontaktieren. Der Widerruf
        hat keinen Einfluss auf die Rechtmäßigkeit der Verarbeitung bis zum Widerruf. Die Daten werden gelöscht, wenn
        der Zweck ihrer Erhebung weggefallen ist und keine Verpflichtung besteht, sie aufzubewahren. Weitere
        Informationen findest du in der Datenschutzerklärung des Anbieters unter
        https://www.whatsapp.com/legal/updates/privacy-policy-eea?lang=en.
      </LegalBodyText>
      <LegalHeadline>4. Datenverarbeitung auf Social Media-Plattformen</LegalHeadline>
      <LegalBodyText>
        Wir sind in Social Media-Netzwerken vertreten, um dort unsere Organisation und unsere Leistungen vorzustellen.
        Die Betreiber dieser Netzwerke verarbeiten Daten ihrer Nutzer regelmäßig zu Werbezwecken. Unter anderem
        erstellen sie aus ihrem Onlineverhalten Nutzerprofile, die beispielsweise dazu verwendet werden, um auf den
        Seiten der Netzwerke und auch sonst im Internet Werbung zu zeigen, die den Interessen der Nutzer entspricht.
        Dazu speichern die Betreiber der Netzwerke Informationen zu dem Nutzungsverhalten in Cookies auf dem Rechner der
        Nutzer. Es ist außerdem nicht auszuschließen, dass die Betreiber diese Informationen mit weiteren Daten
        zusammenführen. Weitere Informationen sowie Hinweise, wie Nutzer der Verarbeitung durch die Seitenbetreiber
        widersprechen können, erhalten Nutzer in den unten aufgeführten Datenschutzerklärungen der jeweiligen Betreiber.
        Es kann auch sein, dass die Betreiber oder ihre Server in Nicht-EU-Staaten sitzen, so dass sie Daten dort
        verarbeiten. Hierdurch können sich für die Nutzer Risiken ergeben, z.B. weil die Durchsetzung ihrer Rechte
        erschwert wird oder staatliche Stellen Zugriff auf die Daten nehmen. Wenn Nutzer der Netzwerke mit uns über
        unsere Profile in Kontakt treten, verarbeiten wir die uns mitgeteilten Daten, um die Anfragen zu beantworten.
        Darin liegt unser berechtigtes Interesse, so dass Rechtsgrundlage Art. 6 Abs. 1 S. 1 lit. f DSGVO ist.
      </LegalBodyText>
      <LegalHeadline>4.1. LinkedIn</LegalHeadline>
      <LegalBodyText>
        Wir unterhalten ein Profil auf LinkedIn. Betreiber ist LinkedIn Ireland Unlimited Company, Wilton Place, Dublin
        2, Irland. Die Datenschutzerklärung ist hier abrufbar:
        https://https://www.linkedin.com/legal/privacy-policy?_l=de_DE. Eine Möglichkeit, der Datenverarbeitung zu
        widersprechen, ergibt sich über die Einstellungen für Werbeanzeigen:
        https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out.
      </LegalBodyText>
      <LegalHeadline>5. Änderungen dieser Datenschutzerklärung</LegalHeadline>
      <LegalBodyText>
        Wir behalten uns das Recht vor, diese Datenschutzerklärung mit Wirkung für die Zukunft zu ändern. Eine aktuelle
        Version ist jeweils hier verfügbar.
      </LegalBodyText>
      <LegalHeadline>6. Fragen und Kommentare</LegalHeadline>
      <LegalBodyText>
        Für Fragen oder Kommentare bezüglich dieser Datenschutzerklärung stehen wir gern unter den oben angegebenen
        Kontaktdaten zur Verfügung.
      </LegalBodyText>
    </LegalPageLayout>
  )

  // return (<div className={styles.root}>
  //     <div className={navBarStyles.headerLarge}>
  //       <nav className={navBarStyles.topBar}>
  //         <Scroll.Link
  //           smooth
  //           offset={-100}
  //           duration={50}
  //           to={"about"}
  //           className={navBarStyles.logo}
  //         >
  //           <Image
  //             src={"/Skinuvita_full_logo.svg"}
  //             width={70}
  //             height={60}
  //             alt={"skinuvita logo"}
  //           />
  //         </Scroll.Link>
  //         <div className={navBarStyles.grow}></div>
  //         <ul className={navBarStyles.tabs}>
  //
  //         </ul>
  //       </nav>
  //     </div>
  //     <Container
  //       fluid
  //       className={styles.main}
  //     >
  //       <Row
  //         id={"team"}
  //         className={classNames(styles.bigRow, styles.team)}
  //       >
  //         <Col
  //           xl={12}
  //           lg={12}
  //           md={12}
  //           className={classNames(styles.teamHeader)}
  //         >
  //           <h3>Privacy policy</h3>
  //         </Col>
  //         For the current tests of the app no user data is shared with other companies. The data is only used for
  //         testing purposes. The current testers will be the developers and other team members of Skinuvita and members of the study. The privacy
  //         policy will be updated before the release to a broader audience.
  //       </Row>
  //     </Container>
  //   </div>)
}
export default Privacy
